<template>
  <ul
    :class="{ 'single-nutshell': nutshells.length === 1 }"
    data-test="campsite-nutshells"
  >
    <li v-for="(nutshell, index) in nutshells" :key="index">
      {{ nutshell }}
      <template v-if="withJumpLink && index === 2">
        <a
          v-scrollto="{
            target: '#description',
            options: { duration: 200, offset: 0 },
          }"
          href="#description"
          class="read-more"
          @click.prevent="$emit('scroll-triggered', '#description')"
          >(<translate>Read more</translate>)</a
        >
      </template>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class PuNutshells extends Vue {
  @Prop({ required: true })
  nutshells!: string[]

  @Prop({ default: false })
  withJumpLink: boolean
}

export default toNative(PuNutshells)
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 1em 0 0.8em 0;
}

li {
  color: var(--colour-text-default);
  font-size: var(--body);
  line-height: 1.2;
  padding: 0 0 0.5em 0;
  text-align: left;
  list-style-image: url('~/assets/images/bullet.svg');
}

li a {
  text-decoration: underline;
  color: var(--colour-text-light);
}

.single-nutshell li {
  list-style: none;
  font-size: var(--small);
}
</style>
